const getters = {
    choiceList: state => state.choice.choiceList,
    choiceSetList: state => state.choice.choiceSetList,
    siteList: state => state.choice.siteList,
    itemList: state => state.choice.itemList,
    catetoryList: state => state.choice.catetoryList,
    menuList: state => state.choice.menuList,
    majorList: state=> state.choice.majorList
}

export default getters;


// WEBPACK FOOTER //
// ./src/store/getters.js